import { NODE_CONTEXT_IMPORT } from "./NodeContextImportConstants";

export const IMPORT_TOAST_DEFAULT_DURATION = 6000;

const toastLabels = () => NODE_CONTEXT_IMPORT.toast;

export function buildImportToastSuccess(description) {
  const t = toastLabels();
  return {
    show: true,
    type: "success",
    title: t.successTitle,
    description: description ?? "",
  };
}

export function buildImportToastFailure(description) {
  const t = toastLabels();
  return {
    show: true,
    type: "failure",
    title: t.errorTitle,
    description: description ?? t.defaultFailureDescription,
  };
}

export function hideImportToast() {
  return {
    show: false,
    type: "success",
    title: "",
    description: "",
  };
}
